import React from "react";
import { useTranslation } from "react-i18next";

export const Results = () => {
  const { t } = useTranslation();
  const stats = t("results.stats", { returnObjects: true }) || [];
  const benefits = t("results.benefits", { returnObjects: true }) || [];

  return (
    <section
      data-testid="results-section"
      className="relative overflow-hidden bg-[hsl(var(--ink))] py-24 text-[hsl(var(--background))] lg:py-32 grain"
    >
      <div className="absolute inset-0 opacity-[0.06]" aria-hidden>
        <svg className="h-full w-full" preserveAspectRatio="none" viewBox="0 0 800 400">
          <defs>
            <pattern id="grid" width="64" height="64" patternUnits="userSpaceOnUse">
              <path d="M 64 0 L 0 0 0 64" fill="none" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--sand))]">
              {t("results.eyebrow")}
            </p>
            <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] text-balance sm:text-5xl lg:text-[4rem]">
              {t("results.title")}
            </h2>
            <ul className="mt-10 space-y-4">
              {benefits.map((b) => (
                <li
                  key={b}
                  className="flex items-center gap-4 border-b border-white/10 pb-4 text-lg text-[hsl(var(--background))]/85"
                >
                  <span className="font-display text-xl text-[hsl(var(--sand))]">→</span>
                  {b}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-4">
              {stats.map((s, i) => (
                <div
                  key={i}
                  data-testid={`stat-${i}`}
                  className="rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur"
                >
                  <p className="font-display text-5xl font-semibold leading-none tracking-tight sm:text-6xl">
                    {s.value}
                  </p>
                  <p className="mt-3 text-sm text-[hsl(var(--background))]/65">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
            <p className="mt-6 text-xs uppercase tracking-[0.2em] text-[hsl(var(--background))]/50">
              {t("results.footnote")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Results;
